import * as React from 'react';
import * as moment from 'moment';
import { RouteComponentProps } from 'react-router';

export class AssessmentComplete extends React.Component<RouteComponentProps<{}>> {
    render() {
        const { state } = this.props.location;

        let bodyText = <h1><strong>You may now close the browser window.</strong></h1>;

        if (state && state.completedDate) {
            bodyText = <h1><strong>You completed this assessment on {moment(state.completedDate).toDate().toDateString()}.</strong></h1>;
        }

        return (
            <div className="Survey">
                <div className="bgBase" />
                <div className="bg" />
                <div className="bg2" />
                <div className="content">
                    <div className="container">
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped" role="progressbar" aria-valuenow={50} aria-valuemin={0} aria-valuemax={100} style={{ width: '100%' }} />
                        </div>
                        <div className="survey-finished">
                            <img src="/images/ThumbsUp.svg" />
                            {bodyText}
                        </div>
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/assessment/AssessmentComplete.tsx